import type { Role } from '../domain/types';

export interface RoleInfo {
  id: Role;
  label: string;
  description: string;
  demoUser: string;
}

/**
 * Portalen har én innlogging med full tilgang («admin»).
 * De tidligere rollene beholdes kun for bakoverkompatibilitet med lagrede kommentarer/forslag.
 */
export const ROLES: RoleInfo[] = [
  {
    id: 'admin',
    label: 'Full tilgang',
    description: 'Alle analyser, kostanslag, rapporter, kildeinnsyn, import, bestillinger og assistent.',
    demoUser: 'Bruker',
  },
  { id: 'ledelse', label: 'Ledelse', description: '', demoUser: 'Ledelse' },
  { id: 'produksjon', label: 'Produksjon', description: '', demoUser: 'Produksjon' },
  { id: 'dataadmin', label: 'Dataadministrator', description: '', demoUser: 'Dataadministrator' },
];

export type Capability =
  | 'view_costs'
  | 'view_sources'
  | 'view_data_quality'
  | 'view_reports'
  | 'view_compare'
  | 'comment'
  | 'change_status'
  | 'save_simulation'
  | 'import'
  | 'reset'
  | 'edit_rates'
  | 'switch_adapter'
  | 'export_source_data';

const ALL: Capability[] = ['view_costs', 'view_sources', 'view_data_quality', 'view_reports', 'view_compare', 'comment', 'change_status', 'save_simulation', 'import', 'reset', 'edit_rates', 'switch_adapter', 'export_source_data'];

const MATRIX: Record<Role, Capability[]> = {
  admin: ALL,
  ledelse: ALL,
  produksjon: ALL,
  dataadmin: ALL,
};

/** Én innlogging = full tilgang. Funksjonen beholdes slik at eksisterende kall fortsetter å virke. */
export function can(role: Role | null | undefined, cap: Capability): boolean {
  if (!role) return false;
  return MATRIX[role]?.includes(cap) ?? true;
}

export function roleInfo(role: Role | null | undefined): RoleInfo | undefined {
  return ROLES.find((r) => r.id === role);
}

export function roleLabel(role: Role | null | undefined): string {
  return roleInfo(role)?.label ?? 'Full tilgang';
}
